/**
 * Returns a new array of values that are unique according to a key function. If
 * no key function is specified, the objects are compared by reference. (Copied over from Admin Frontend Toolbox)
 */
export const uniqueBy = <T, U>(arr: T[], keyFn?: (x: T) => U) => {
  const seen = new Set();
  return arr.filter((item) => {
    const key = keyFn ? keyFn(item) : item;
    return seen.has(key) ? false : seen.add(key);
  });
};
